import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from '@shared/auth';
import { DatastoreOnlineOfflineModule } from '@shared/datastore/online-offline';
import { OnlineIndicatorComponent } from './online-indicator/online-indicator.component';
import { OnlineStatusComponent } from './online-status.component';

@NgModule({
  imports: [CommonModule, AuthModule, DatastoreOnlineOfflineModule],
  declarations: [OnlineStatusComponent, OnlineIndicatorComponent],
  exports: [OnlineStatusComponent],
})
export class OnlineStatusModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/online-status/online-status.module.ts